import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
import Popup from "./popup";
import PopupOtb from "./popupOTB";
import moment from "moment";
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });
 

function Mapa({lista, listMarcador,  listPoliOtb, listRecorrido,listColPolig, rutaSeleccion  }) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef()
    const [long] = useState(-98.8802521); 
    const [lat] = useState(19.3172475 );
    const [zoom] = useState(12);       
    const [regisSelect, setRegisSelect] = useState([]);
    const [marcadores, setMarcadores] = useState([]);
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [regisPopUpOtb, setRegisPopUpOtb] = useState([]);
    const [listaNum, setListaNum] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);
     
    let hoveredStateId = null;
    let stateName = null;

 
    useEffect(() => {       
        //console.log(typeof lista, lista);
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: lista.length!==0 ? [lista[0][0], lista[0][1]] : (listRecorrido.length!==0 ? [listRecorrido[0].Lon,listRecorrido[0].Lat]: ([long,lat]) ),
            zoom: zoom            
        });

         
     
        setRegisSelect(lista)
        return () => {
            mapRef.current.remove()
        }
    }, [    ]);

    useEffect(()=>{
       if (lista.length!==0) {
        //console.log(listMarcador);
        
        const auxCoordenadas=lista
        /*  lista.forEach((registro)=>{
            auxCoordenadas.push({... registro.coordinates})
        })  */
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('maine', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        // These coordinates outline Maine.
                        'coordinates': [
                            auxCoordenadas
                        ]
                    }
                }
            });

            // Add a new layer to visualize the polygon.
          /*   mapRef.current.addLayer({
                'id': 'maine',
                'type': 'fill',
                'source': 'maine', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#0080ff', // blue color fill
                    'fill-opacity': 0.5
                }
            }); */
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'maine',
                'layout': {},
                'paint': {
                    'line-color': '#af272f',
                    'line-width': 3
                }
            });
            });
            if (listMarcador && listMarcador.length!==0) {
                setMarcadores(listMarcador)    
            }
            
        }
 
    },[lista ])

     useEffect(()=>{
      
                
       if (listPoliOtb.length!==0) {
 
        
        const auxCoordenadas=listPoliOtb
        /*  lista.forEach((registro)=>{
            auxCoordenadas.push({... registro.coordinates})
        })  */
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('otbs', {
                'type': 'geojson',
                'data':auxCoordenadas/* {  
                    'type': 'Feature',
                    'geometry': {
                        'type': 'MultiPolygon',                        
                        'coordinates': auxCoordenadas                        
                    }
                }  */
            });

            // Add a new layer to visualize the polygon.
            mapRef.current.addLayer({
                'id': 'fill-otbs',
                'type': 'fill',
                'source': 'otbs', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color':   '#cedded', // blue color fill
                    'fill-opacity': 0.5
                }
            });
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline-otbs',
                'type': 'line',
                'source': 'otbs',
                'layout': {},
                'paint': {
                    'line-color':listColPolig,////["match",["get", "IdOTB"],[81],'#eb4034',[82],"#97ca7f",'#cedded'],
                    'line-width': 3
                }
            });
            });
             
           
        }

        if (listRecorrido && listRecorrido.length!==0) {
            mapRef.current.flyTo({
                center:[ listRecorrido[0].Lon, listRecorrido[0].Lat],
                zoom:15
            }); 
            setListaNum(listRecorrido) 
       
        }
        
 
    },[listPoliOtb, listRecorrido])

    useEffect(()=>{
        if (rutaSeleccion.length!==0) {
            mapRef.current.flyTo({
                center:[ rutaSeleccion.Lon, rutaSeleccion.Lat],
                zoom:15
            });
        }
    },[rutaSeleccion])

    const onClickUnidad=(aux)=>{
        
        //console.log(aux);
        const nvo={...aux,
            properties:{texto: aux.original.nom, dir: aux.original.dir, 
                otb:aux.original.otbNom},
            geometry:{coordinates:aux.coordinates}}
        //console.log(nvo);
        setRegisPopUpOtb([])
        setRegisPopUp(nvo)
    }

    const onClickOtb=(elemento)=>{
        //console.log(aux);
        const aux=elemento.original
        setRegisPopUp([])
        
        //console.log(aux);
        
        const fecha=moment.utc(aux.FEnv).local(true).format("DD/MM/YYYY HH:mm")
        setRegisPopUpOtb({...aux,
            properties:{Tipo: aux.TipoNom, fecha:fecha, usuario:aux.UsrNom, Distrito:aux.DtoNom, 
                Cantidad:aux.Cantidad, Observ:aux.Obsrv, Direcc:aux.Direcc},
            geometry:{coordinates:elemento.coordinates}})
    }

    return (
    <div className={classes.miclase} style={{width:window.innerWidth - 90,height: window.innerHeight - 140}} >
       
        {<div id="districtDetailMap" className={"map"} >
            <div style={{width:window.innerWidth - 90,height: window.innerHeight - 140}} ref={mapContainer}>
            </div>
 
           
            {  listaNum.length !== 0 ?
                listaNum.map((elemento,index)=>{
                    //console.log(elemento);
                    
                    const estilo ={width:"30px", height:"38px"}
                    return<MarcadorGoT
                    key={elemento.Id}
                    map={mapRef.current}
                    feature={{coordinates:[elemento.Lon,elemento.Lat], original:elemento}}
                    onClick={onClickOtb}
                    estilo={estilo}
                     
                /> 
               } )
               
            :null  }

            {mapRef.current && regisPopUp.length!==0 ? (
                <Popup
                    map={mapRef.current}
                    activeFeature={regisPopUp}
                />
            )
            :null}

             {mapRef.current && regisPopUpOtb.length!==0 ? (
                <PopupOtb
                    map={mapRef.current}
                    activeFeature={regisPopUpOtb}
                />
            )
            :null}
        </div>}
    </div>
    );
}

export default Mapa;